(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kbs-best-sellers-native"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kbs-best-sellers')) {
    customElements.define('kbs-best-sellers', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        this.cache = new Map();
        this.tabs = Array.from(this.querySelectorAll('[data-ranking-tab]'));
        this.panel = this.querySelector('[role="tabpanel"]');
        this.results = this.querySelector('[data-ranking-results]');
        this.status = this.querySelector('[data-ranking-status]');
        this.viewAll = this.querySelector('[data-ranking-view-all]');
        this.tabs.forEach(tab => {
          tab.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.activate(tab);
          }, { signal: this.events.signal });
          tab.addEventListener('keydown', event => {
            const index = this.tabs.indexOf(tab);
            const rtl = getComputedStyle(this).direction === 'rtl';
            let next;
            if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
            if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            const target = this.tabs[(next + this.tabs.length) % this.tabs.length];
            target.focus();
            this.activate(target);
          }, { signal: this.events.signal });
        });
        document.addEventListener('shopify:block:select', event => {
          const tab = this.tabs.find(item => item.dataset.blockId === event.detail.blockId);
          if (tab) this.activate(tab);
        }, { signal: this.events.signal });
        if (this.dataset.needsLoad === 'true') this.activate(this.tabs[0]);
      }

      disconnectedCallback() {
        this.events?.abort();
        this.request?.abort();
      }

      async activate(tab) {
        if (!tab) return;
        this.request?.abort();
        this.request = new AbortController();
        const controller = this.request;
        const destination = new URL(tab.href, window.location.origin);
        const key = destination.pathname + destination.search;
        this.panel.setAttribute('aria-busy', 'true');
        this.status.textContent = '';
        try {
          let html = this.cache.get(key);
          if (!html) {
            destination.searchParams.set('section_id', this.dataset.sectionId);
            destination.searchParams.set('_ranking_version', this.dataset.renderVersion);
            const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
            if (previewTheme) destination.searchParams.set('preview_theme_id', previewTheme);
            const response = await fetch(destination, { signal: controller.signal });
            if (!response.ok) throw new Error('Ranking unavailable');
            const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
            const content = documentFragment.querySelector('[data-ranking-results]');
            if (!content || content.querySelector('.kbs-ranking__loading')) throw new Error('Ranking unavailable');
            html = content.innerHTML;
            this.cache.set(key, html);
          }
          if (controller.signal.aborted) return;
          this.results.innerHTML = html;
          this.tabs.forEach(item => {
            item.setAttribute('aria-selected', String(item === tab));
            item.tabIndex = item === tab ? 0 : -1;
          });
          this.panel.setAttribute('aria-labelledby', tab.id);
          this.viewAll.href = tab.href;
          this.dataset.needsLoad = 'false';
          tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.status.textContent = this.querySelector('[data-ranking-error]').content.textContent.trim();
          }
        } finally {
          if (!controller.signal.aborted) this.panel.setAttribute('aria-busy', 'false');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kbs-best-sellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kbs-best-sellers')) {
    customElements.define('kbs-best-sellers', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        this.cache = new Map();
        this.tabs = Array.from(this.querySelectorAll('[data-ranking-tab]'));
        this.panel = this.querySelector('[role="tabpanel"]');
        this.results = this.querySelector('[data-ranking-results]');
        this.status = this.querySelector('[data-ranking-status]');
        this.viewAll = this.querySelector('[data-ranking-view-all]');
        this.tabs.forEach(tab => {
          tab.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.activate(tab);
          }, { signal: this.events.signal });
          tab.addEventListener('keydown', event => {
            const index = this.tabs.indexOf(tab);
            const rtl = getComputedStyle(this).direction === 'rtl';
            let next;
            if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
            if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            const target = this.tabs[(next + this.tabs.length) % this.tabs.length];
            target.focus();
            this.activate(target);
          }, { signal: this.events.signal });
        });
        document.addEventListener('shopify:block:select', event => {
          const tab = this.tabs.find(item => item.dataset.blockId === event.detail.blockId);
          if (tab) this.activate(tab);
        }, { signal: this.events.signal });
        if (this.dataset.needsLoad === 'true') this.activate(this.tabs[0]);
      }

      disconnectedCallback() {
        this.events?.abort();
        this.request?.abort();
      }

      async activate(tab) {
        if (!tab) return;
        this.request?.abort();
        this.request = new AbortController();
        const controller = this.request;
        const destination = new URL(tab.href, window.location.origin);
        const key = destination.pathname + destination.search;
        this.panel.setAttribute('aria-busy', 'true');
        this.status.textContent = '';
        try {
          let html = this.cache.get(key);
          if (!html) {
            destination.searchParams.set('section_id', this.dataset.sectionId);
            destination.searchParams.set('_ranking_version', this.dataset.renderVersion);
            const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
            if (previewTheme) destination.searchParams.set('preview_theme_id', previewTheme);
            const response = await fetch(destination, { signal: controller.signal });
            if (!response.ok) throw new Error('Ranking unavailable');
            const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
            const content = documentFragment.querySelector('[data-ranking-results]');
            if (!content || content.querySelector('.kbs-ranking__loading')) throw new Error('Ranking unavailable');
            html = content.innerHTML;
            this.cache.set(key, html);
          }
          if (controller.signal.aborted) return;
          this.results.innerHTML = html;
          this.tabs.forEach(item => {
            item.setAttribute('aria-selected', String(item === tab));
            item.tabIndex = item === tab ? 0 : -1;
          });
          this.panel.setAttribute('aria-labelledby', tab.id);
          this.viewAll.href = tab.href;
          this.dataset.needsLoad = 'false';
          tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.status.textContent = this.querySelector('[data-ranking-error]').content.textContent.trim();
          }
        } finally {
          if (!controller.signal.aborted) this.panel.setAttribute('aria-busy', 'false');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kbs-brand-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kbs-brand-products')) {
    customElements.define('kbs-brand-products', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const section = this.closest('.kbs-brand-spotlight');
        this.panels = [...this.querySelectorAll('[data-brand-collection]')];
        this.tabs = this.panels.map(panel => [...section.querySelectorAll('.section-global__header a[href]')].find(link => new URL(link.href).pathname.replace(/\/$/, '') === new URL(panel.dataset.brandUrl, location.origin).pathname.replace(/\/$/, '')));
        if (this.tabs.some(tab => !tab) || !this.tabs.length) return;
        const tablist = this.tabs[0].parentElement;
        tablist.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.id = this.panels[index].id + '-tab';
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', event => {
            if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.select(index);
          }, { signal });
          tab.addEventListener('keydown', event => {
            let next = index;
            const direction = getComputedStyle(tablist).direction === 'rtl' ? -1 : 1;
            if (event.key === 'ArrowRight') next += direction;
            else if (event.key === 'ArrowLeft') next -= direction;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else if (event.key === ' ') {
              event.preventDefault();
              this.select(index);
              return;
            } else return;
            event.preventDefault();
            next = (next + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus();
          }, { signal });
        });
        this.select(0);
      }
      select(index) {
        this.tabs.forEach((tab, position) => {
          const active = position === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.panels[position].hidden = !active;
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
